export function mapFirebaseAuthError(error: unknown, mode: 'login' | 'signup' | 'social' | 'passwordReset' = 'login') {
  const code =
    typeof error === 'object' && error !== null && 'code' in error
      ? String((error as { code?: string }).code ?? '')
      : ''

  switch (code) {
    case 'auth/invalid-email':
      return 'Vul een geldig e-mailadres in.'
    case 'auth/user-disabled':
      return 'Dit account is uitgeschakeld.'
    case 'auth/user-not-found':
    case 'auth/wrong-password':
    case 'auth/invalid-credential':
      return 'Ongeldig e-mailadres of wachtwoord.'
    case 'auth/too-many-requests':
      return 'Te veel pogingen. Probeer het later opnieuw.'
    case 'auth/network-request-failed':
      return 'Er is geen verbinding met Firebase.'
    case 'auth/email-already-in-use':
      return 'Voor dit e-mailadres bestaat al een account.'
    case 'auth/weak-password':
      return 'Kies een sterker wachtwoord.'
    case 'auth/account-exists-with-different-credential':
      return 'Er bestaat al een account met dit e-mailadres via een andere inlogmethode.'
    case 'auth/popup-closed-by-user':
      return ''
    default:
      switch (mode) {
        case 'signup':
          return 'Account aanmaken is mislukt. Probeer het opnieuw.'
        case 'social':
          return 'Inloggen via deze provider is mislukt.'
        case 'passwordReset':
          return 'We konden nu geen resetlink versturen.'
        case 'login':
        default:
          return 'Inloggen is mislukt. Probeer het opnieuw.'
      }
  }
}
